module.exports = __webpack_public_path__ + "img/2_5.382dfa04.png";